function windowHeight() {
   const windowHeight = window.innerHeight;
   return windowHeight;
 } 
 function headerHeight() { 
   if(document.body.contains(document.querySelector('[data-site-header]'))) {
   const headerHeight = document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
   return headerHeight;
   } else {
     return;
   }
 } 
 function cartFooter() {
   const cartFooterHeight = document.querySelector('.drawer__footer').offsetHeight;
   return cartFooterHeight;
 } 
 function announcementHeight() { 
   if(document.body.contains(document.querySelector('.announcement-bar-container'))) {
      const announcementHeight = document.querySelector('.announcement-bar-container').offsetHeight; 
      //console.log(announcementHeight);
      if(announcementHeight == 0) {
         return 36;
      } else {
      return announcementHeight;
      }
      } else {
        return 0;
      } 
 }

function halfPageOffset() {
   if(document.body.contains(document.querySelector('.page-width'))) {
   const container = document.querySelector('.page-width');
   const offset = container.offsetLeft;
   return offset;

   }
}


 document.documentElement.style.setProperty('--window-height', windowHeight() + 'px'); 
 document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');
 document.documentElement.style.setProperty('--half-page-offset', halfPageOffset() + 'px');
 document.documentElement.style.setProperty('--cart-footer-height', cartFooter() + 'px');
 document.documentElement.style.setProperty('--announcement-height', announcementHeight() + 'px');

window.addEventListener('resize', debounce(function() {
   document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');
   document.documentElement.style.setProperty('--window-height', windowHeight() + 'px');
   document.documentElement.style.setProperty('--cart-footer-height', cartFooter() + 'px'); 
   document.documentElement.style.setProperty('--half-page-offset', halfPageOffset() + 'px');
   document.documentElement.style.setProperty('--announcement-height', announcementHeight() + 'px');
}, 50)); 


window.addEventListener('scroll', debounce(function() {
  document.documentElement.style.setProperty('--header-height', headerHeight() + 'px');
  document.documentElement.style.setProperty('--window-height', windowHeight() + 'px');
  document.documentElement.style.setProperty('--cart-footer-height', cartFooter() + 'px'); 
  document.documentElement.style.setProperty('--half-page-offset', halfPageOffset() + 'px');
  document.documentElement.style.setProperty('--announcement-height', announcementHeight() + 'px');
}, 550)); 

window.addEventListener('load', (event) => {
   document.documentElement.style.setProperty('--announcement-height', announcementHeight() + 'px');
 });
  

// URL PARAMETERS
function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
}

 /************ STICKY HEADER ***************/
 
 const siteHeader = document.querySelector('[data-site-header]');
 
    if(siteHeader) {  
    function fixHeader() { 
          const stickyOffset = siteHeader.offsetHeight + 200;  
          const stickyOffset2 =   windowHeight(); 

          const scroll = window.scrollY; 
     


          if (scroll > stickyOffset ) {
            if(!siteHeader.classList.contains('scrolling','fixed')) { 
           siteHeader.classList.add('scrolling');
           siteHeader.classList.add('fixed');
            }
          } else {
            if(siteHeader.classList.contains('scrolling','fixed')) { 
             siteHeader.classList.remove('scrolling');
             siteHeader.classList.remove('fixed');
            }
          }



          if (scroll > stickyOffset2 ) { 
           siteHeader.classList.add('extended-scrolling');  
          } else { 
             siteHeader.classList.remove('extended-scrolling');  
          }

       }



       window.addEventListener('touchmove', debounce(function() { 
        fixHeader();
       }, 50)); 

    window.addEventListener('scroll', debounce(function() { 
      fixHeader();
     }, 50)); 

    window.addEventListener('resize', debounce(function() { 
       fixHeader();
    }, 50));  

    window.addEventListener('load', (event) => { 
      fixHeader();
   });
 } 


 
/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  if (event.target.dataset.toggleTarget) {
    //console.log('toggle');
    slideToggle(event);
  }
  if (event.target.dataset.tabTarget) {
    //console.log('tab');
    tabToggle(event);
  }
  if(event.target.dataset.modalTarget) {
    //console.log('Modal');
    modalPop(event);
  }
});


/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  event.preventDefault();
  //console.log('slide down toggle');
  
  const toggles = document.querySelectorAll('[data-toggle-target]');
  const targets = document.querySelectorAll('[data-toggle-content]'); 
  const target = event.target.dataset.toggleTarget;
  console.log(target, 'TARGET');
  const toggleContainer = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );
  //console.log(toggleContainer, 'TOGGLE CONTAINER'); 
  toggleContainer.forEach((group) => { 

    const toggleSlider = group.querySelectorAll('.bd-slider');

    if (!group.classList.contains('active')) { 
      toggles.forEach((toggle)=> {
        if(toggle.dataset.toggleTarget == target) {
        toggle.classList.add('active');
        }
      }); 

      group.classList.add('active');
      group.style.height = 'auto'; 
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';

      setTimeout(function () { 
        group.style.height = height;
      }, 0);

      group.addEventListener('transitionend', function () {
          console.log('transition end');
          group.style.height = 'auto';
        },
        {
          once: true,
        }
      );

   // SLIDER FIX
   if (toggleSlider.length > 0) { 
    toggleSlider.forEach((slider) => { 
      const flktySlider = Flickity.data(slider);
       console.log('resize toggle sliders');
      flktySlider.resize();
    }); 
    }

    } else {
      toggles.forEach((toggle)=> {
        //console.log(toggle.dataset.toggleTarget, 'DATA TARGET');
        if(toggle.dataset.toggleTarget == target) {
        toggle.classList.remove('active');
        }
      }); 
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      console.log(height, 'height');
      group.style.height = height;

      setTimeout(function () {
        group.style.height = height;
        group.classList.remove('active');
        group.style.height = '0px';
       // console.log('remove active', group); 
      }, 0);
      group.addEventListener(
        'transitionend',
        function () { 
         // console.log('close toggle transition end');
          group.style.height = '0px';
        },
        {
           once: true,
        }
      );
    } 
  });
 

  

  // FOR RESETTING ALL ITEMS

  if (event.target.hasAttribute('data-reset')) {
    toggles.forEach((toggle) => {
      if (
        (toggle.dataset.toggleTarget == target) &
        toggle.classList.contains('active')
      ) {
        toggle.classList.remove('active');
      } else {
        toggle.classList.add('active');
      }
      if (toggle.dataset.toggleTarget != target) {
        toggle.classList.remove('active');
      }
    });
    targets.forEach((toggle) => {
      if (toggle.dataset.toggleContent != target) {
        toggle.classList.remove('active');
      }
    });
  }
}

/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();
  const target = event.target.dataset.tabTarget;
 
  const tabGroup = event.target.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
  tabGroups.forEach((group) => {
    group.classList.remove('active');
  });
  event.target.classList.add('active');



  document
    .querySelectorAll(
      `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
    )
    .forEach((group, index) => {
  
      group.classList.add('active');
      if(index === 1) {
        const parent = group.parentNode;
        console.log('PARENT NODE', parent, headerHeight());
        const offset = parent.offsetTop - headerHeight();
      
        if (parent.offsetTop < window.scrollY) {
        window.scrollTo({
          top: offset,
          behavior: "smooth",
        });
        console.log(offset, 'OFFSET SCROLL TO');
      }
      }
    }); 
} 
  
 
// MODAL TOGGLING 
function modalPop(event) {
  //console.log(event);
  event.preventDefault();
  const target = event.target.dataset.modalTarget;
  const modalContent = document.querySelector(
    `[data-modal-content="${target}"]`
  );
  const closeModal = modalContent.querySelectorAll('[data-close]');
  const modalSlider = modalContent.querySelectorAll('.bd-slider');
  //console.log('open modal');
  modalContent.classList.add('active');
  document.querySelector('body').classList.add('overflow-hidden');

  closeModal.forEach((close) => {
    close.onclick = function () {
      //  console.log('close modal');
      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    };
  });


  window.onclick = function (event) {
    // console.log(event);
    if (event.target == modalContent) {
      // console.log('close modal');

      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  };
  window.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  });

  if (modalSlider) { 
    modalSlider.forEach((slider) => { 
      const flktySlider = Flickity.data(slider);
      // console.log('resize slider');
      flktySlider.resize();
    }); 
    }
}
  

 /************* PRODUCT PAGE SCRIPTS ****************/
 $('[data-calculator-toggle]').on('click', function (e) {
    e.preventDefault();
    var target = $(this).data('calculator-toggle');
    $('[data-calculator="' + target + '"]').addClass('active');
 })

 $('[data-feeding-calc-submit]').on('click', function (e) {
    e.preventDefault();
    var container = $(this).closest('[data-calculator]');
   //console.log('results');
    $('[data-calculations-area]', container).hide();
    $('[data-feeding-calc-results]', container).show();
    var age = $('input[name="age"]:checked', container).val();
    // console.log('AGE', age);
    var active = 1;
    if (age < 3) {
       active = $('input[name="activity"]:checked', container).val();
    }
    //console.log('active', active);

    var weight = $('select[name="weight"]', container).val(); 
    var cupsInBag = $('[data-cups-bag]', container).val();
     console.log('cups', cupsInBag);
    var bagsNeeded = (weight * 7 / cupsInBag * active * age).toFixed(1); 
    var bagsNeededSplit = bagsNeeded.toString().split('.'); 
     //console.log('bagsNeeded', bagsNeeded); 

    // const activeType = bodyType < 1 && bodyType == active ? active : bodyType * active;

    var cupsPerDay = (weight * active * age).toFixed(1);  
    var cupsPerDaySplit = cupsPerDay.toString().split('.'); 
    //console.log(cupsPerDaySplit[1]);
    let cupsWhole; 
    function buildWhole(whole) {
       if (parseInt(whole) == 0) {
          cupsWhole = ''
       } else {
          cupsWhole = parseInt(whole);
       }
       return cupsWhole;
    }

    function buildFraction(fraction) {
       let fractionAmount;
       switch (parseInt(fraction)) {
          case 0:
             fractionAmount = '';
             break;
          case 1:
             fractionAmount = '<sup>1</sup>&frasl;<sub>4</sub>';
             break;
          case 2:
             fractionAmount = '<sup>1</sup>&frasl;<sub>4</sub>';
             break;
          case 3:
             fractionAmount = '<sup>1</sup>&frasl;<sub>3</sub>';
             break;
          case 4:
             fractionAmount = '<sup>1</sup>&frasl;<sub>2</sub>';
             break;
          case 5:
             fractionAmount = '<sup>1</sup>&frasl;<sub>2</sub>';
             break;
          case 6:
             fractionAmount = '<sup>2</sup>&frasl;<sub>3</sub>';
             break;
          case 7:
             fractionAmount = '<sup>2</sup>&frasl;<sub>3</sub>';
             break;
          case 8:
             fractionAmount = '<sup>3</sup>&frasl;<sub>4</sub>';
             break;
          case 9:
             fractionAmount = '<sup>3</sup>&frasl;<sub>4</sub>';
       }
       return fractionAmount;
    } 
    $('[data-cups-per-day]', container).html(buildWhole(cupsPerDaySplit[0]) + ' ' + buildFraction(cupsPerDaySplit[1]));
    $('[data-bags-per-week]', container).html(buildWhole(bagsNeededSplit[0]) + ' ' + buildFraction(bagsNeededSplit[1]));

 }); 
 function resetCalculator(e) { 
    $('[data-calculations-area]').show();
    $('[data-feeding-calc-results]').hide();
 }


 $('[data-reset-calculator]').on('click',function(e){
   resetCalculator();
 })


 function getUrlParameter(sParam) {
   var sPageURL = window.location.search.substring(1),
     sURLVariables = sPageURL.split('&'),
     sParameterName,
     i;
 
   for (i = 0; i < sURLVariables.length; i++) {
     sParameterName = sURLVariables[i].split('=');
 
     if (sParameterName[0] === sParam) {
       return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
     }
   }
 };


// INTERCOM CHAT 

const chatButtons =  document.querySelectorAll('[data-chat]'); 
chatButtons.forEach((chatOpen) => {   
   chatOpen.onclick = function(event) {   
  if(window.screen.width > 749) {
     if(chatOpen.classList.contains('active')){
        Intercom('hide');
       chatButtons.forEach((chatOpen) => {   
       chatOpen.classList.remove('active');
       });
     } else {
       Intercom('show');
       chatButtons.forEach((chatOpen) => {   
       chatOpen.classList.add('active');
       });
     }
  } else {
   Intercom('show');
   }
 }
 }); 
 

 const openCart = getUrlParameter('cart'); 
 if(openCart == 'open' ) {
  window.addEventListener('load', function() {
   console.log(openCart,'cartURL');
   document.getElementById('cart-icon-bubble').click();
   });
 } 

 const openCalc = getUrlParameter('calc');
 if(openCalc == 'open' ){
   $('[data-modal-target="calc"]').click();
 } 

 const openMenu = getUrlParameter('menu');
 if(openMenu == 'open' ){
   $('[data-modal-target="food-menu"]').click();
 }
  
 
 window.addEventListener('load', function() {
   console.log('Page is loaded');
   $('product-form').addClass('active');
});
 


 
/************ Smooth Scroll  ****************/

document.querySelectorAll('a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target])').forEach((anchor) => {   
   anchor.addEventListener('click', function(e){
      e.preventDefault();
         console.log('scroll to ', e);
         const offset = headerHeight() * -2;
         if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
         let target = anchor.hash;
         target = target.length ? target : document.querySelector(`[name="${this.hash.slice(1)}"]`);

       
       
         if (target.length) {   
          const element = document.getElementById(target.replace('#',''));
          console.log('element', element)
            window.scrollTo({
               top: getOffsetTop(element) + offset,
               left: 0,
               behavior: 'smooth'
             });
      
          }
 
         }  
   });
}); 

function getOffsetTop(element) {
  return element ? (element.offsetTop + getOffsetTop(element.offsetParent)) : 0;
}



const randomValue = Math.random(); // Generates a random value between 0 and 1


function splitURL(path, parameter, randomValue) {
  const links = document.querySelectorAll(`a[href="${path}"]`);

  links.forEach((link) => {
    if (randomValue >= 0.5) {
      link.setAttribute('href', `${path}?${parameter}=A`);
    } else {
      link.setAttribute('href', `${path}?${parameter}=B`);
    }
  }); 
}

const urlCoupon = getUrlParameter('utm_coupon');
const discount = getUrlParameter('discount');

if(urlCoupon) {
  localStorage.setItem('urlCoupon', urlCoupon);
}

if(discount) {
  localStorage.setItem('planDiscount', parseInt(discount));
}